import { TimelineResultResponse } from '@business/entities/dashboard';
import { LogService } from '@business/services';
import { R } from '@core/utils/r';
import { toMoment } from '@core/utils/time';
import React, { memo, useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { WidgetProps } from '../types';

interface SingleTimelineProps {
  item: TimelineResultResponse;
  isFade?: boolean;
}
const SingleTimeline = memo((props: SingleTimelineProps) => {
  const { item, isFade = false } = props;
  const color = useMemo(() => LogService.getLogColor(item.action), [item.action]);
  const mDate = useMemo(() => toMoment(item.createdAt), [item.createdAt]);
  return (
    <li className="event-list pb-4 pl-3">
      <div className="event-timeline-dot">
        <i className={`bx bx-right-arrow-circle font-size-18 ${isFade ? 'bx-fade-righttt' : ''}`}></i>
      </div>
      <div className="media">
        <div className="me-3">
          <h5 className={`font-size-16 text-${color}`}>
            {mDate.format('D MMM')}
            <i className={`${LogService.getIcon(item.type)} font-size-16 mr-2 ml-2 `} />
            {/* <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i> */}
          </h5>
        </div>
        <div className="media-body">
          <span style={{ marginBottom: '0.1rem', fontSize: 14 }}>{LogService.getJSX(item.title, item)}</span>
        </div>
      </div>
    </li>
  );
});

export const TimelineWidget = memo((props: WidgetProps<TimelineResultResponse[]>) => {
  const { settings, result } = props;
  return (
    <Card style={{ marginBottom: 0, flex: 1 }}>
      <CardBody>
        <div className="d-flex">
          <div className="me-2">
            <h5 className="card-title mb-4">{settings.title || 'Timeline'}</h5>
          </div>
        </div>
        <SimpleBar style={{ maxHeight: '90%' }}>
          <div className="mt-2">
            <ul className="verti-timeline list-unstyled">
              {R.isArray(result) &&
                R.map(result, (log, index) => {
                  return <SingleTimeline item={log} isFade={index === 0} />;
                })}
            </ul>
          </div>
        </SimpleBar>
      </CardBody>
    </Card>
  );
});
